import React from 'react';
import { getIn, useFormikContext } from 'formik';

import { ErrorHelperTextFormik } from '~/components/core/Formik/ErrorHelperTextFormik';
import MultiSelectAutoComplete from '~/components/core/Molecules/Fields/MultiSelectAutoComplete';

export interface MultiSelectAutoCompleteFormikProps<T> {
  id: string;
  label?: string;
  options: T[];
  getOptionLabel: (option: T) => string;
  onChange?: (value?: T[] | null) => void;
  disabled?: boolean;
  className?: string;
  limitTags?: number;
}

const MultiSelectAutoCompleteFormik = <T,>({
  id,
  label,
  options,
  getOptionLabel,
  onChange,
  disabled = false,
  className,
  limitTags,
}: MultiSelectAutoCompleteFormikProps<T>): JSX.Element => {
  const { values, setFieldValue } = useFormikContext<Record<string, T[] | unknown>>();

  const formikValue = getIn(values, id) as T[] | undefined;
  const selectedValues = formikValue || [];

  const handleSelectionChange = (value: T[] | null | undefined) => {
    setFieldValue(id, value || []);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <>
      <MultiSelectAutoComplete
        id={id}
        label={label}
        options={options}
        value={selectedValues}
        getOptionLabel={getOptionLabel}
        onChange={handleSelectionChange}
        disabled={disabled}
        className={className}
        limitTags={limitTags}
      />
      <ErrorHelperTextFormik id={id} />
    </>
  );
};

export default MultiSelectAutoCompleteFormik;
